import { Button } from '@platform/ui';

import { useMessages } from '../i18n';
import { useResendEmailVerification } from '../lib/account';

/**
 * A nudge, not a wall: the panel keeps working with an unverified address, but
 * says so on every screen until the link in the mail is followed.
 */
export function VerifyEmailBanner() {
    const t = useMessages();
    const resend = useResendEmailVerification();

    return (
        <div
            role="status"
            className="flex flex-wrap items-center justify-center gap-3 border-b border-border bg-warning-subtle px-4 py-2 text-13 text-foreground"
        >
            <span>{resend.isSuccess ? t.verifyEmail.sent : resend.isError ? t.verifyEmail.sendFailed : t.verifyEmail.banner}</span>
            {!resend.isSuccess && (
                <Button size="sm" variant="secondary" loading={resend.isPending} onClick={() => resend.mutate()}>
                    {t.verifyEmail.resend}
                </Button>
            )}
        </div>
    );
}
